module.exports = __webpack_public_path__ + "static/media/nb_akademie_medium_italic-webfont.f3fba386.ttf";